import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  Companion_getInstance3chrc9ba7w7cn as Companion_getInstance,
  SerializableAnnotation2h7cqfq6xt1yy as SerializableAnnotation,
  Companion_getInstance335jj07k1liay as Companion_getInstance_0,
  Companion_getInstance22u7dztn23hkn as Companion_getInstance_1,
  Companion_instance1m0a2cblw7mu as Companion_instance,
  Companion_getInstance3dkx52fv8xbgz as Companion_getInstance_2,
  Companion_getInstance1vhrrts3tgqok as Companion_getInstance_3,
  Companion_getInstance28kbswf0q4ib as Companion_getInstance_4,
  Companion_getInstance17duyot40gy2l as Companion_getInstance_5,
  Companion_getInstance40jjb0q1rrt7 as Companion_getInstance_6,
  NullValue_getInstance1rsbaonhpgnfm as NullValue_getInstance,
  Companion_instance1uwi5qveups5a as Companion_instance_0,
  Companion_instanceyg0acnb3y8ur as Companion_instance_1,
  Companion_instancenv8tmv5nw040 as Companion_instance_2,
  Companion_instance2hsf7r151zjoj as Companion_instance_3,
  Companion_instance1z65nhbsy3ljt as Companion_instance_4,
  Companion_instance3k60yjsjepcqz as Companion_instance_5,
  Companion_instances6uwm8m0c2sh as Companion_instance_6,
  Companion_instance2xnezqm8k4iy6 as Companion_instance_7,
  Companion_instance2o7nx4336u4bs as Companion_instance_8,
  Companion_instance1gz05lw05kmgt as Companion_instance_9,
  Companion_getInstancendigucsaw94a as Companion_getInstance_7,
} from './serialization/VirtualType.mjs';
import { to2cs3ny02qtbcb as to } from '../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { mapOf2zpbbmyqk8xpf as mapOf } from '../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import {
  emptyMapr06gerzljqtm as emptyMap,
  mapOf1xd03cq9cnmy8 as mapOf_0,
} from '../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { Companion_getInstance3eoge8j03l9b5 as Companion_getInstance_8 } from './serialization/SerializationRegistry.mjs';
import { prepareWebAuthNCredentialFields19ow30dgtlau4 as prepareWebAuthNCredentialFields } from './lightningserver/auth/proof/WebAuthNCredentialFields.mjs';
import { prepareOtpSecretFields1uppd2f3lkgqy as prepareOtpSecretFields } from './lightningserver/auth/proof/OtpSecretFields.mjs';
import { preparePasswordSecretFields123t1fj46m6bp as preparePasswordSecretFields } from './lightningserver/auth/proof/PasswordSecretFields.mjs';
import { prepareKnownDeviceSecretFields17wic287aey8t as prepareKnownDeviceSecretFields } from './lightningserver/auth/proof/KnownDeviceSecretFields.mjs';
import { prepareOauthClientFields2f6ht6w7u5ryt as prepareOauthClientFields } from './lightningserver/auth/oauth/OauthClientFields.mjs';
import { prepareOauthClientSecretFieldswj0m8xuir3ej as prepareOauthClientSecretFields } from './lightningserver/auth/oauth/OauthClientSecretFields.mjs';
import { prepareSessionFields3a2t5uz9d2yuy as prepareSessionFields } from './lightningserver/auth/subject/SessionFields.mjs';
import { prepareExternalAsyncTaskRequestFieldshbi2ejghvwsa as prepareExternalAsyncTaskRequestFields } from './lightningserver/externalintegration/ExternalAsyncTaskRequestFields.mjs';
import { prepareHealthStatusFields3rwycni69473l as prepareHealthStatusFields } from './lightningserver/serverhealth/HealthStatusFields.mjs';
import { prepareServerHealthFields25n3y2v2tv5cq as prepareServerHealthFields } from './lightningserver/serverhealth/ServerHealthFields.mjs';
import { prepareMemoryFieldsdeb4svr86fio as prepareMemoryFields } from './lightningserver/serverhealth/MemoryFields.mjs';
import { prepareReportedExceptionGroupFields36kjijsp4e6fr as prepareReportedExceptionGroupFields } from './lightningserver/exceptions/ReportedExceptionGroupFields.mjs';
import { prepareUploadForNextRequestFieldsxbhgnoa28aao as prepareUploadForNextRequestFields } from './lightningserver/files/UploadForNextRequestFields.mjs';
import { prepareServerFileWithMetadataFields1v03v7klkn1h7 as prepareServerFileWithMetadataFields } from './lightningserver/media/ServerFileWithMetadataFields.mjs';
import { prepareServerFileWithMetadataPreviewFields1uah4xzwvf5za as prepareServerFileWithMetadataPreviewFields } from './lightningserver/media/ServerFileWithMetadataPreviewFields.mjs';
import { prepareFunnelSummaryFields2gae6rz3ojln2 as prepareFunnelSummaryFields } from './lightningserver/monitoring/FunnelSummaryFields.mjs';
import { prepareFunnelInstanceFields2vjcvz3qv4dsq as prepareFunnelInstanceFields } from './lightningserver/monitoring/FunnelInstanceFields.mjs';
import { prepareModelPermissionsFields15lzayqlczylt as prepareModelPermissionsFields } from './lightningdb/ModelPermissionsFields.mjs';
import { prepareMaskFields1vyea3qdqniax as prepareMaskFields } from './lightningdb/MaskFields.mjs';
import { prepareUpdateRestrictionsPartFieldsg3v4fkxma8t1 as prepareUpdateRestrictionsPartFields } from './lightningdb/UpdateRestrictionsPartFields.mjs';
import { prepareUpdateRestrictionsFieldsqqn8zo8u2pcf as prepareUpdateRestrictionsFields } from './lightningdb/UpdateRestrictionsFields.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  Companion_instance20zkfeibsiypi as Companion_instance_10,
  Companion_instance2lv9vrt1es5f2 as Companion_instance_11,
  Companion_instancep5538yw9sfln as Companion_instance_12,
  Companion_getInstancesldiilhozd0o as Companion_getInstance_9,
  Companion_instance2lqekn5oedduv as Companion_instance_13,
} from './StringAlts.mjs';
import {
  Companion_instance2ohraxbyim7rf as Companion_instance_14,
  Companion_instancevghyayl33eva as Companion_instance_15,
} from './ZonedDateTime.mjs';
import { Companion_getInstance3n9as6ds1py67 as Companion_getInstance_10 } from './UUID.js.mjs';
import {
  Companion_instance3nlomj2jjs1fp as Companion_instance_16,
  Companion_instancexvm2tzznrout as Companion_instance_17,
  Companion_instance1olveu2h2p0bp as Companion_instance_18,
  Companion_instance2aphy0qwzrjp9 as Companion_instance_19,
  Companion_instance3heqqn8gfw4dg as Companion_instance_20,
  Companion_instance2sdho14d7q7c5 as Companion_instance_21,
  Companion_instance3guk37so2mnmx as Companion_instance_22,
  Companion_instance2bdpnlo55frwb as Companion_instance_23,
  Companion_instancen5s0hxc4knyr as Companion_instance_24,
  Companion_instance384swmewitwnw as Companion_instance_25,
  Companion_instance17glu83oz0rte as Companion_instance_26,
  Companion_instance1l92zutxh2ysq as Companion_instance_27,
} from './usefulTypes.mjs';
import { Companion_instancei6s1qtvf2v72 as Companion_instance_28 } from './lightningserver/LSError.mjs';
import { Companion_getInstance4nebw1aefgxh as Companion_getInstance_11 } from './lightningserver/websocket/MultiplexMessage.mjs';
import {
  Companion_getInstance1os58gbbjei8z as Companion_getInstance_12,
  Companion_instance142n4cw0cx0vy as Companion_instance_29,
  Companion_instance2f9qz66nhm21c as Companion_instance_30,
  Companion_getInstance2t29tjgmmdesl as Companion_getInstance_13,
  Companion_getInstance11brt9mg8u6o3 as Companion_getInstance_14,
  Companion_getInstanceq9bpui01g1r5 as Companion_getInstance_15,
  Companion_getInstance2yo4wmuc8aop as Companion_getInstance_16,
  Companion_getInstance3moa2zk1h7b6i as Companion_getInstance_17,
  Companion_getInstance2jgeip11toh8t as Companion_getInstance_18,
  Companion_getInstance4ivu8l0d0qdj as Companion_getInstance_19,
  Companion_instancevoo46bgnocyv as Companion_instance_31,
  Companion_instancepvrn1rfebb8p as Companion_instance_32,
} from './lightningserver/auth/proof/WebAuthN.mjs';
import { Companion_getInstance2nqzk98fbkur7 as Companion_getInstance_20 } from './lightningserver/auth/proof/OtpHashAlgorithm.mjs';
import {
  Companion_getInstance139kwuiq3xn4y as Companion_getInstance_21,
  Companion_instance1a8y12exr3m74 as Companion_instance_33,
  Companion_instance1fvvx9vzv7oo5 as Companion_instance_34,
  Companion_instance3ewbpovhpt7ut as Companion_instance_35,
  Companion_instance7fo6qco5btbo as Companion_instance_36,
} from './lightningserver/auth/proof/AuthSecrets.mjs';
import {
  Companion_instance1ih0rts2yeaav as Companion_instance_37,
  Companion_instance1pkyovfo1ue86 as Companion_instance_38,
  Companion_instance34pd77z7qkvav as Companion_instance_39,
  Companion_instancegcdka3oz2z8g as Companion_instance_40,
  Companion_instance14gv80x39ekce as Companion_instance_41,
  Companion_getInstanceljo2w2l50tif as Companion_getInstance_22,
  Companion_getInstance24vxhhaq3p126 as Companion_getInstance_23,
  Companion_instanceijunt7dscbn as Companion_instance_42,
  Companion_getInstance3vf10yxur8dlu as Companion_getInstance_24,
} from './lightningserver/auth/proof/proofModels.mjs';
import {
  Companion_getInstance3azjmcnlvtkjq as Companion_getInstance_25,
  Companion_getInstance210kkjgxlt93z as Companion_getInstance_26,
  Companion_instance2q8sycmjnf360 as Companion_instance_43,
  Companion_instance37i54e09zz7vj as Companion_instance_44,
  Companion_instance1i62rqxozutzl as Companion_instance_45,
  Companion_getInstanceqngcll8xsq51 as Companion_getInstance_27,
  Companion_getInstance2w2jkppf7qvjb as Companion_getInstance_28,
  Companion_getInstance3jl0ukwxkdn4x as Companion_getInstance_29,
  Companion_getInstance10khgktosjic0 as Companion_getInstance_30,
} from './lightningserver/auth/oauth/models.mjs';
import {
  Companion_getInstance2pteqjzccrqe9 as Companion_getInstance_31,
  Companion_getInstance1dz3q9fvss53i as Companion_getInstance_32,
  Companion_getInstancedici4y8vd124 as Companion_getInstance_33,
  Companion_getInstance2bk062dpuj8t4 as Companion_getInstance_34,
  Companion_getInstance3332ape10v2ob as Companion_getInstance_35,
} from './lightningserver/auth/subject/subjectModels.mjs';
import { NothingSerializer3oixyyf77l4xt as NothingSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import {
  Companion_instanceoexmrian6dpx as Companion_instance_46,
  Companion_instance1d4dbx3jji78w as Companion_instance_47,
  Companion_instance3pds0w11gibwr as Companion_instance_48,
} from './lightningserver/auth/old/EmailPinLogin.mjs';
import { Companion_getInstance2j3pmvyptu679 as Companion_getInstance_36 } from './lightningserver/externalintegration/ExternalAsyncTaskRequest.mjs';
import {
  Companion_getInstance3m865vivtv009 as Companion_getInstance_37,
  Companion_getInstance3i96z74mcv2y1 as Companion_getInstance_38,
  Companion_getInstance7ri1umalrfbk as Companion_getInstance_39,
  Companion_instance1y2fclwwulp17 as Companion_instance_49,
} from './lightningserver/serverhealth/HealthStatus.mjs';
import { Companion_getInstance13bmzv5tuee6 as Companion_getInstance_40 } from './lightningserver/exceptions/ReportedException.mjs';
import {
  Companion_getInstancehaaffmnyyk0 as Companion_getInstance_41,
  Companion_instanceifrpuc0mopdh as Companion_instance_50,
  Companion_getInstance3mcqt6tk88j0w as Companion_getInstance_42,
} from './lightningserver/schema/models.mjs';
import {
  Companion_instancedr8ewd9slv0o as Companion_instance_51,
  Companion_instancevf9zg0jswem5 as Companion_instance_52,
} from './lightningserver/typed/BulkRequest.mjs';
import {
  Companion_getInstance173agu3fofr81 as Companion_getInstance_43,
  Companion_instance3dz2aen8k3fc7 as Companion_instance_53,
} from './lightningserver/files/UploadEarlyEndpointModels.mjs';
import {
  Companion_getInstance9bcftd4fcpen as Companion_getInstance_44,
  Companion_getInstance3ribnrb9tntrx as Companion_getInstance_45,
} from './lightningserver/media/ServerFileWithMetadata.mjs';
import {
  Companion_getInstance31693c80p58in as Companion_getInstance_46,
  Companion_getInstance11v66jrt2are4 as Companion_getInstance_47,
} from './lightningserver/db/DumpRequest.mjs';
import {
  Companion_instance2jzcizpuuma18 as Companion_instance_54,
  Companion_getInstance35jta5xdhkpv2 as Companion_getInstance_48,
  Companion_getInstance1plstrcui6kcy as Companion_getInstance_49,
} from './lightningserver/monitoring/models.mjs';
import { Companion_instance1kjus4hvx4qjx as Companion_instance_55 } from './serialization/DataClassPath.mjs';
import { Companion_instance77mblgbd9v4t as Companion_instance_56 } from './serialization/Partial.mjs';
import { Companion_instance2o2rsvptme3gi as Companion_instance_57 } from './GeoCoordinate.mjs';
import { Companion_getInstance2ox6dwbhzwjsb as Companion_getInstance_50 } from './lightningdb/QueryPartial.mjs';
import { Companion_getInstance23ulzawec7mjy as Companion_getInstance_51 } from './lightningdb/ModelPermissions.mjs';
import {
  Companion_instancek13g6rikuawd as Companion_instance_58,
  Never_getInstance32s86skpi7zck as Never_getInstance,
  Always_getInstancecs10mhg5aot2 as Always_getInstance,
  Companion_instance3axtksx96wcm8 as Companion_instance_59,
  Companion_instance3kfd7pkebp1l6 as Companion_instance_60,
  Companion_instance1kshdbaa2euyc as Companion_instance_61,
  Companion_instance3ak5m32y5x4a2 as Companion_instance_62,
  Companion_instance3rhh32thymhrm as Companion_instance_63,
  Companion_instanceykgiia56hplq as Companion_instance_64,
  Companion_instance1wmugroxx6its as Companion_instance_65,
  Companion_instance1pnby10k4drrs as Companion_instance_66,
  Companion_instance1bxyifpo36xxj as Companion_instance_67,
  Companion_instance3gb3zm5gnr6a5 as Companion_instance_68,
  Companion_instance218unjc9ltn4s as Companion_instance_69,
  Companion_instance4ohr4qgu4dpv as Companion_instance_70,
  Companion_getInstancej2hha9qybp58 as Companion_getInstance_52,
  Companion_instance2djixj65v0cw7 as Companion_instance_71,
  Companion_getInstanceltmei8szg1mh as Companion_getInstance_53,
  Companion_instance286iy1cgt2utf as Companion_instance_72,
  Companion_instance2l9p65638ljnl as Companion_instance_73,
  Companion_instance1tkgi2p65guqx as Companion_instance_74,
  Companion_instance17kutko0aqeid as Companion_instance_75,
  Companion_instance2ox6qhwp298su as Companion_instance_76,
  Companion_instance1wdeuj7afw8ax as Companion_instance_77,
  Companion_instancexmfl72rqr3f8 as Companion_instance_78,
  Companion_instance1fynquy6dsj9i as Companion_instance_79,
  Companion_instance3uymr7onrbkwm as Companion_instance_80,
  Companion_instance1fklk3p9r3exr as Companion_instance_81,
  Companion_instance3a5r5sd3blktl as Companion_instance_82,
  Companion_instance393e5hna3az6 as Companion_instance_83,
  Companion_getInstance3i17w8wcrpav1 as Companion_getInstance_54,
  Companion_instance2ro4l92elzn9p as Companion_instance_84,
} from './lightningdb/Condition.mjs';
import {
  Companion_getInstance1khfkwo5dix9p as Companion_getInstance_55,
  Companion_getInstance2me4dixbj0lj0 as Companion_getInstance_56,
  Companion_getInstance2r8wjyblz0idz as Companion_getInstance_57,
} from './lightningdb/GroupCountQuery.mjs';
import {
  Companion_instance30d6g5ap8rdfm as Companion_instance_85,
  Nothing_getInstance2cox2iic6p9qw as Nothing_getInstance,
  Companion_instanceh1zhnl1id9u6 as Companion_instance_86,
  Companion_instance3iz3lmuiwm4gs as Companion_instance_87,
  Companion_instance2xh5qtziumx9l as Companion_instance_88,
  Companion_instance3b2ql10d66of8 as Companion_instance_89,
  Companion_instance2bxh5k04i38vl as Companion_instance_90,
  Companion_instance1803vszd3jkgu as Companion_instance_91,
  Companion_instance3jdqbmrdwjecn as Companion_instance_92,
  Companion_instance3i2oc9fl7dqwb as Companion_instance_93,
  Companion_instance1stph8yw2qjt5 as Companion_instance_94,
  Companion_instanceqw27e6orr13x as Companion_instance_95,
  Companion_instance3tbsu8lc454o8 as Companion_instance_96,
  Companion_instance3l6pokebxu46n as Companion_instance_97,
  Companion_instanceplmfjmw1b8eo as Companion_instance_98,
  Companion_instance1u3htj9m9i4vw as Companion_instance_99,
  Companion_getInstance15on8pfywvj4u as Companion_getInstance_58,
  Companion_instanceogftm8o6mnqa as Companion_instance_100,
  Companion_instance1za9qc8wkqj85 as Companion_instance_101,
  Companion_instancexixyq1cxutlm as Companion_instance_102,
  Companion_instance1thnnb3838mfv as Companion_instance_103,
  Companion_instance2992tql2kbmd as Companion_instance_104,
  Companion_getInstance3kmlqavk0jt8f as Companion_getInstance_59,
  Companion_instance35mjssmfxcqi1 as Companion_instance_105,
  Companion_instance1cmtpto9j9iy1 as Companion_instance_106,
  Companion_instance1mmg08h7zlnuq as Companion_instance_107,
} from './lightningdb/Modification.mjs';
import { Companion_getInstanceqo1s9uxbxjme as Companion_getInstance_60 } from './lightningdb/CollectionChanges.mjs';
import { Companion_getInstance1p5xjdbhmj22t as Companion_getInstance_61 } from './lightningdb/Query.mjs';
import { Companion_getInstance2zg1j1fxqbni0 as Companion_getInstance_62 } from './lightningdb/Mask.mjs';
import { Companion_getInstance15uq20f985jxw as Companion_getInstance_63 } from './lightningdb/MassModification.mjs';
import { Companion_instance1wlwjbzvod7vj as Companion_instance_108 } from './lightningdb/SortPart.mjs';
import { Companion_getInstancetl9eamf8zl9j as Companion_getInstance_64 } from './lightningdb/Aggregate.mjs';
import { Companion_getInstance2cg5mffg7iayj as Companion_getInstance_65 } from './lightningdb/EntryChange.mjs';
import { Companion_getInstance8oiu9odho220 as Companion_getInstance_66 } from './lightningdb/CollectionUpdates.mjs';
import { Companion_getInstance2cclvpun048fq as Companion_getInstance_67 } from './lightningdb/ListChange.mjs';
import {
  Companion_getInstance9xluupucl4vq as Companion_getInstance_68,
  Companion_getInstance1gfb55agtbi7k as Companion_getInstance_69,
} from './lightningdb/UpdateRestrictions.mjs';
import {
  Companion_getInstance3o44jbz1kg34s as Companion_getInstance_70,
  Companion_instance968c7ignz3xx as Companion_instance_109,
} from './validation/validate.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function prepareModelsShared() {
  SharedModelsObject_getInstance();
}
function SharedModelsObject$lambda(it) {
  return new (SerializableAnnotation())('com.lightningkite.lightningdb.NaturalSort', mapOf(to('fields', Companion_getInstance().l3h(it.j3h_1))));
}
function SharedModelsObject$lambda_0(it) {
  return new (SerializableAnnotation())('com.lightningkite.lightningdb.AdminSearchFields', mapOf(to('fields', Companion_getInstance().l3h(it.m3h_1))));
}
function SharedModelsObject$lambda_1(it) {
  return new (SerializableAnnotation())('com.lightningkite.lightningdb.AdminTableColumns', mapOf(to('fields', Companion_getInstance().l3h(it.n3h_1))));
}
function SharedModelsObject$lambda_2(it) {
  return new (SerializableAnnotation())('com.lightningkite.lightningdb.AdminTitleFields', mapOf(to('fields', Companion_getInstance().l3h(it.o3h_1))));
}
function SharedModelsObject$lambda_3(it) {
  // Inline function 'kotlin.collections.mapOf' call
  var tmp$ret$0 = emptyMap();
  return new (SerializableAnnotation())('com.lightningkite.lightningdb.AdminHidden', tmp$ret$0);
}
function SharedModelsObject$lambda_4(it) {
  // Inline function 'kotlin.collections.mapOf' call
  var tmp$ret$0 = emptyMap();
  return new (SerializableAnnotation())('com.lightningkite.lightningdb.AdminViewOnly', tmp$ret$0);
}
function SharedModelsObject$lambda_5(it) {
  // Inline function 'kotlin.collections.mapOf' call
  var tmp$ret$0 = emptyMap();
  return new (SerializableAnnotation())('com.lightningkite.lightningdb.Multiline', tmp$ret$0);
}
function SharedModelsObject$lambda_6(it) {
  return new (SerializableAnnotation())('com.lightningkite.lightningdb.UiWidget', mapOf(to('type', Companion_getInstance().l3h(it.p3h_1))));
}
function SharedModelsObject$lambda_7(it) {
  return new (SerializableAnnotation())('com.lightningkite.lightningdb.JsonSchemaFormat', mapOf(to('format', Companion_getInstance().l3h(it.q3h_1))));
}
function SharedModelsObject$lambda_8(it) {
  return new (SerializableAnnotation())('com.lightningkite.lightningdb.IntegerRange', mapOf_0([to('min', Companion_getInstance().l3h(it.r3h_1)), to('max', Companion_getInstance().l3h(it.s3h_1))]));
}
function SharedModelsObject$lambda_9(it) {
  return new (SerializableAnnotation())('com.lightningkite.lightningdb.FloatRange', mapOf_0([to('min', Companion_getInstance().l3h(it.t3h_1)), to('max', Companion_getInstance().l3h(it.u3h_1))]));
}
function SharedModelsObject$lambda_10(it) {
  return new (SerializableAnnotation())('com.lightningkite.lightningdb.ExpectedPattern', mapOf(to('pattern', Companion_getInstance().l3h(it.v3h_1))));
}
function SharedModelsObject$lambda_11(it) {
  return new (SerializableAnnotation())('com.lightningkite.lightningdb.DisplayName', mapOf(to('text', Companion_getInstance().l3h(it.w3h_1))));
}
function SharedModelsObject$lambda_12(it) {
  return new (SerializableAnnotation())('com.lightningkite.lightningdb.Hint', mapOf(to('text', Companion_getInstance().l3h(it.x3h_1))));
}
function SharedModelsObject$lambda_13(it) {
  return new (SerializableAnnotation())('com.lightningkite.lightningdb.MimeType', mapOf_0([to('types', Companion_getInstance().l3h(it.y3h_1)), to('maxSize', Companion_getInstance().l3h(it.z3h_1))]));
}
function SharedModelsObject$lambda_14(it) {
  return new (SerializableAnnotation())('com.lightningkite.lightningdb.MaxLength', mapOf_0([to('size', Companion_getInstance().l3h(it.a3i_1)), to('average', Companion_getInstance().l3h(it.b3i_1))]));
}
function SharedModelsObject$lambda_15(it) {
  return new (SerializableAnnotation())('com.lightningkite.lightningdb.MaxSize', mapOf_0([to('size', Companion_getInstance().l3h(it.c3i_1)), to('average', Companion_getInstance().l3h(it.d3i_1))]));
}
function SharedModelsObject$lambda_16(it) {
  return new (SerializableAnnotation())('com.lightningkite.lightningdb.Denormalized', mapOf(to('calculationId', Companion_getInstance().l3h(it.e3i_1))));
}
function SharedModelsObject$lambda_17(it) {
  return new (SerializableAnnotation())('com.lightningkite.lightningdb.Description', mapOf(to('text', Companion_getInstance().l3h(it.f3i_1))));
}
function SharedModelsObject$lambda_18(it) {
  return new (SerializableAnnotation())('com.lightningkite.lightningdb.References', mapOf_0([to('references', Companion_getInstance().l3h(it.g3i_1)), to('reverseName', Companion_getInstance().l3h(it.h3i_1))]));
}
function SharedModelsObject$lambda_19(it) {
  return new (SerializableAnnotation())('com.lightningkite.lightningdb.MultipleReferences', mapOf_0([to('references', Companion_getInstance().l3h(it.i3i_1)), to('reverseName', Companion_getInstance().l3h(it.j3i_1))]));
}
function SharedModelsObject$lambda_20(it) {
  // Inline function 'kotlin.collections.mapOf' call
  var tmp$ret$0 = emptyMap();
  return new (SerializableAnnotation())('com.lightningkite.lightningdb.DoesNotNeedLabel', tmp$ret$0);
}
function SharedModelsObject$lambda_21(it) {
  return new (SerializableAnnotation())('com.lightningkite.lightningdb.Group', mapOf(to('name', Companion_getInstance().l3h(it.k3i_1))));
}
function SharedModelsObject$lambda_22(it) {
  return new (SerializableAnnotation())('com.lightningkite.lightningdb.Sentence', mapOf(to('text', Companion_getInstance().l3h(it.l3i_1))));
}
function SharedModelsObject$lambda_23(it) {
  return new (SerializableAnnotation())('com.lightningkite.lightningdb.Importance', mapOf(to('size', Companion_getInstance().l3h(it.m3i_1))));
}
function SharedModelsObject$lambda_24(it) {
  // Inline function 'kotlin.collections.mapOf' call
  var tmp$ret$0 = emptyMap();
  return new (SerializableAnnotation())('com.lightningkite.lightningdb.Index', tmp$ret$0);
}
function SharedModelsObject$lambda_25(it) {
  // Inline function 'kotlin.collections.mapOf' call
  var tmp$ret$0 = emptyMap();
  return new (SerializableAnnotation())('com.lightningkite.lightningdb.Unique', tmp$ret$0);
}
function SharedModelsObject$lambda_26(it) {
  return new (SerializableAnnotation())('com.lightningkite.lightningdb.TextIndex', mapOf(to('fields', Companion_getInstance().l3h(it.n3i_1))));
}
function SharedModelsObject$lambda_27(it) {
  return new (SerializableAnnotation())('com.lightningkite.lightningdb.IndexSet', mapOf(to('fields', Companion_getInstance().l3h(it.o3i_1))));
}
function SharedModelsObject$lambda_28(it) {
  return new (SerializableAnnotation())('com.lightningkite.lightningdb.UniqueSet', mapOf(to('fields', Companion_getInstance().l3h(it.p3i_1))));
}
function SharedModelsObject$lambda_29(it) {
  return new (SerializableAnnotation())('com.lightningkite.lightningdb.NamedIndex', mapOf(to('indexName', Companion_getInstance().l3h(it.q3i_1))));
}
function SharedModelsObject$lambda_30(it) {
  return new (SerializableAnnotation())('com.lightningkite.lightningdb.NamedUnique', mapOf(to('indexName', Companion_getInstance().l3h(it.r3i_1))));
}
function SharedModelsObject$lambda_31(it) {
  return new (SerializableAnnotation())('com.lightningkite.lightningdb.NamedIndexSet', mapOf_0([to('fields', Companion_getInstance().l3h(it.s3i_1)), to('indexName', Companion_getInstance().l3h(it.t3i_1))]));
}
function SharedModelsObject$lambda_32(it) {
  return new (SerializableAnnotation())('com.lightningkite.lightningdb.NamedUniqueSet', mapOf_0([to('fields', Companion_getInstance().l3h(it.u3i_1)), to('indexName', Companion_getInstance().l3h(it.v3i_1))]));
}
var SharedModelsObjectClass;
function SharedModelsObject() {
  if (SharedModelsObjectClass === VOID) {
    class $ {
      constructor() {
        SharedModelsObject_instance = this;
        registerShared(Companion_getInstance_8().x3i_1);
        prepareWebAuthNCredentialFields();
        prepareOtpSecretFields();
        preparePasswordSecretFields();
        prepareKnownDeviceSecretFields();
        prepareOauthClientFields();
        prepareOauthClientSecretFields();
        prepareSessionFields();
        prepareExternalAsyncTaskRequestFields();
        prepareHealthStatusFields();
        prepareServerHealthFields();
        prepareMemoryFields();
        prepareReportedExceptionGroupFields();
        prepareUploadForNextRequestFields();
        prepareServerFileWithMetadataFields();
        prepareServerFileWithMetadataPreviewFields();
        prepareFunnelSummaryFields();
        prepareFunnelInstanceFields();
        prepareModelPermissionsFields();
        var tmp = Companion_getInstance_0();
        tmp.a3j('com.lightningkite.lightningdb.NaturalSort', SharedModelsObject$lambda);
        var tmp_0 = Companion_getInstance_0();
        tmp_0.a3j('com.lightningkite.lightningdb.AdminSearchFields', SharedModelsObject$lambda_0);
        var tmp_1 = Companion_getInstance_0();
        tmp_1.a3j('com.lightningkite.lightningdb.AdminTableColumns', SharedModelsObject$lambda_1);
        var tmp_2 = Companion_getInstance_0();
        tmp_2.a3j('com.lightningkite.lightningdb.AdminTitleFields', SharedModelsObject$lambda_2);
        var tmp_3 = Companion_getInstance_0();
        tmp_3.a3j('com.lightningkite.lightningdb.AdminHidden', SharedModelsObject$lambda_3);
        var tmp_4 = Companion_getInstance_0();
        tmp_4.a3j('com.lightningkite.lightningdb.AdminViewOnly', SharedModelsObject$lambda_4);
        var tmp_5 = Companion_getInstance_0();
        tmp_5.a3j('com.lightningkite.lightningdb.Multiline', SharedModelsObject$lambda_5);
        var tmp_6 = Companion_getInstance_0();
        tmp_6.a3j('com.lightningkite.lightningdb.UiWidget', SharedModelsObject$lambda_6);
        var tmp_7 = Companion_getInstance_0();
        tmp_7.a3j('com.lightningkite.lightningdb.JsonSchemaFormat', SharedModelsObject$lambda_7);
        var tmp_8 = Companion_getInstance_0();
        tmp_8.a3j('com.lightningkite.lightningdb.IntegerRange', SharedModelsObject$lambda_8);
        var tmp_9 = Companion_getInstance_0();
        tmp_9.a3j('com.lightningkite.lightningdb.FloatRange', SharedModelsObject$lambda_9);
        var tmp_10 = Companion_getInstance_0();
        tmp_10.a3j('com.lightningkite.lightningdb.ExpectedPattern', SharedModelsObject$lambda_10);
        var tmp_11 = Companion_getInstance_0();
        tmp_11.a3j('com.lightningkite.lightningdb.DisplayName', SharedModelsObject$lambda_11);
        var tmp_12 = Companion_getInstance_0();
        tmp_12.a3j('com.lightningkite.lightningdb.Hint', SharedModelsObject$lambda_12);
        var tmp_13 = Companion_getInstance_0();
        tmp_13.a3j('com.lightningkite.lightningdb.MimeType', SharedModelsObject$lambda_13);
        var tmp_14 = Companion_getInstance_0();
        tmp_14.a3j('com.lightningkite.lightningdb.MaxLength', SharedModelsObject$lambda_14);
        var tmp_15 = Companion_getInstance_0();
        tmp_15.a3j('com.lightningkite.lightningdb.MaxSize', SharedModelsObject$lambda_15);
        var tmp_16 = Companion_getInstance_0();
        tmp_16.a3j('com.lightningkite.lightningdb.Denormalized', SharedModelsObject$lambda_16);
        var tmp_17 = Companion_getInstance_0();
        tmp_17.a3j('com.lightningkite.lightningdb.Description', SharedModelsObject$lambda_17);
        var tmp_18 = Companion_getInstance_0();
        tmp_18.a3j('com.lightningkite.lightningdb.References', SharedModelsObject$lambda_18);
        var tmp_19 = Companion_getInstance_0();
        tmp_19.a3j('com.lightningkite.lightningdb.MultipleReferences', SharedModelsObject$lambda_19);
        var tmp_20 = Companion_getInstance_0();
        tmp_20.a3j('com.lightningkite.lightningdb.DoesNotNeedLabel', SharedModelsObject$lambda_20);
        var tmp_21 = Companion_getInstance_0();
        tmp_21.a3j('com.lightningkite.lightningdb.Group', SharedModelsObject$lambda_21);
        var tmp_22 = Companion_getInstance_0();
        tmp_22.a3j('com.lightningkite.lightningdb.Sentence', SharedModelsObject$lambda_22);
        var tmp_23 = Companion_getInstance_0();
        tmp_23.a3j('com.lightningkite.lightningdb.Importance', SharedModelsObject$lambda_23);
        var tmp_24 = Companion_getInstance_0();
        tmp_24.a3j('com.lightningkite.lightningdb.Index', SharedModelsObject$lambda_24);
        var tmp_25 = Companion_getInstance_0();
        tmp_25.a3j('com.lightningkite.lightningdb.Unique', SharedModelsObject$lambda_25);
        var tmp_26 = Companion_getInstance_0();
        tmp_26.a3j('com.lightningkite.lightningdb.TextIndex', SharedModelsObject$lambda_26);
        var tmp_27 = Companion_getInstance_0();
        tmp_27.a3j('com.lightningkite.lightningdb.IndexSet', SharedModelsObject$lambda_27);
        var tmp_28 = Companion_getInstance_0();
        tmp_28.a3j('com.lightningkite.lightningdb.UniqueSet', SharedModelsObject$lambda_28);
        var tmp_29 = Companion_getInstance_0();
        tmp_29.a3j('com.lightningkite.lightningdb.NamedIndex', SharedModelsObject$lambda_29);
        var tmp_30 = Companion_getInstance_0();
        tmp_30.a3j('com.lightningkite.lightningdb.NamedUnique', SharedModelsObject$lambda_30);
        var tmp_31 = Companion_getInstance_0();
        tmp_31.a3j('com.lightningkite.lightningdb.NamedIndexSet', SharedModelsObject$lambda_31);
        var tmp_32 = Companion_getInstance_0();
        tmp_32.a3j('com.lightningkite.lightningdb.NamedUniqueSet', SharedModelsObject$lambda_32);
        prepareMaskFields();
        prepareUpdateRestrictionsPartFields();
        prepareUpdateRestrictionsFields();
      }
    }
    initMetadataForObject($, 'SharedModelsObject');
    SharedModelsObjectClass = $;
  }
  return SharedModelsObjectClass;
}
var SharedModelsObject_instance;
function SharedModelsObject_getInstance() {
  if (SharedModelsObject_instance === VOID)
    new (SharedModelsObject())();
  return SharedModelsObject_instance;
}
function registerShared(_this__u8e3s4) {
  _this__u8e3s4.f3j(Companion_instance_10.k2a());
  _this__u8e3s4.f3j(Companion_instance_11.k2a());
  _this__u8e3s4.f3j(Companion_instance_12.k2a());
  _this__u8e3s4.f3j(Companion_getInstance_9().k2a());
  _this__u8e3s4.f3j(Companion_instance_13.k2a());
  _this__u8e3s4.f3j(Companion_instance_14.k2a());
  _this__u8e3s4.f3j(Companion_instance_15.k2a());
  _this__u8e3s4.f3j(Companion_getInstance_10().k2a());
  _this__u8e3s4.f3j(Companion_instance_16.k2a());
  _this__u8e3s4.f3j(Companion_instance_17.k2a());
  _this__u8e3s4.f3j(Companion_instance_18.k2a());
  _this__u8e3s4.f3j(Companion_instance_19.k2a());
  _this__u8e3s4.f3j(Companion_instance_20.k2a());
  _this__u8e3s4.f3j(Companion_instance_21.k2a());
  _this__u8e3s4.f3j(Companion_instance_22.k2a());
  _this__u8e3s4.f3j(Companion_instance_23.k2a());
  _this__u8e3s4.f3j(Companion_instance_24.k2a());
  _this__u8e3s4.f3j(Companion_instance_25.k2a());
  _this__u8e3s4.f3j(Companion_instance_26.k2a());
  _this__u8e3s4.f3j(Companion_instance_27.k2a());
  _this__u8e3s4.f3j(Companion_instance_28.k2a());
  _this__u8e3s4.f3j(Companion_getInstance_11().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_12().k2a());
  _this__u8e3s4.f3j(Companion_instance_29.k2a());
  _this__u8e3s4.f3j(Companion_instance_30.k2a());
  _this__u8e3s4.f3j(Companion_getInstance_13().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_14().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_15().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_16().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_17().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_18().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_19().k2a());
  _this__u8e3s4.f3j(Companion_instance_31.k2a());
  _this__u8e3s4.f3j(Companion_instance_32.k2a());
  _this__u8e3s4.f3j(Companion_getInstance_20().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_21().k2a());
  _this__u8e3s4.f3j(Companion_instance_33.k2a());
  _this__u8e3s4.f3j(Companion_instance_34.k2a());
  _this__u8e3s4.f3j(Companion_instance_35.k2a());
  _this__u8e3s4.f3j(Companion_instance_36.k2a());
  _this__u8e3s4.f3j(Companion_instance_37.k2a());
  _this__u8e3s4.f3j(Companion_instance_38.k2a());
  _this__u8e3s4.f3j(Companion_instance_39.k2a());
  _this__u8e3s4.f3j(Companion_instance_40.k2a());
  _this__u8e3s4.f3j(Companion_instance_41.k2a());
  _this__u8e3s4.f3j(Companion_getInstance_22().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_23().k2a());
  _this__u8e3s4.f3j(Companion_instance_42.k2a());
  _this__u8e3s4.f3j(Companion_getInstance_24().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_25().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_26().k2a());
  _this__u8e3s4.f3j(Companion_instance_43.k2a());
  _this__u8e3s4.f3j(Companion_instance_44.k2a());
  _this__u8e3s4.f3j(Companion_instance_45.k2a());
  _this__u8e3s4.f3j(Companion_getInstance_27().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_28().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_29().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_30().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_31().k2a());
  var tmp = Companion_getInstance_32().x2y(NothingSerializer(), NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp, registerShared$lambda);
  _this__u8e3s4.f3j(Companion_getInstance_33().k2a());
  var tmp_0 = Companion_getInstance_34().c3k(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_0, registerShared$lambda_0);
  var tmp_1 = Companion_getInstance_35().c3k(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_1, registerShared$lambda_1);
  _this__u8e3s4.f3j(Companion_instance_46.k2a());
  _this__u8e3s4.f3j(Companion_instance_47.k2a());
  _this__u8e3s4.f3j(Companion_instance_48.k2a());
  _this__u8e3s4.f3j(Companion_getInstance_36().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_37().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_38().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_39().k2a());
  _this__u8e3s4.f3j(Companion_instance_49.k2a());
  _this__u8e3s4.f3j(Companion_getInstance_40().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_41().k2a());
  _this__u8e3s4.f3j(Companion_instance_50.k2a());
  _this__u8e3s4.f3j(Companion_getInstance_42().k2a());
  _this__u8e3s4.f3j(Companion_instance_51.k2a());
  _this__u8e3s4.f3j(Companion_instance_52.k2a());
  _this__u8e3s4.f3j(Companion_getInstance_43().k2a());
  _this__u8e3s4.f3j(Companion_instance_53.k2a());
  _this__u8e3s4.f3j(Companion_getInstance_44().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_45().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_46().k2a());
  var tmp_2 = Companion_getInstance_47().b2j(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_2, registerShared$lambda_2);
  _this__u8e3s4.f3j(Companion_instance_54.k2a());
  _this__u8e3s4.f3j(Companion_getInstance_48().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_49().k2a());
  var tmp_3 = Companion_instance_55.l3k(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_3, registerShared$lambda_3);
  var tmp_4 = Companion_instance_56.b2j(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_4, registerShared$lambda_4);
  _this__u8e3s4.f3j(Companion_getInstance_1().k2a());
  _this__u8e3s4.f3j(Companion_instance.k2a());
  _this__u8e3s4.f3j(Companion_getInstance_2().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_3().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_4().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_5().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_6().k2a());
  _this__u8e3s4.f3j(Companion_getInstance_0().k2a());
  _this__u8e3s4.f3j(Companion_getInstance().k2a());
  _this__u8e3s4.f3j(NullValue_getInstance().k2a());
  _this__u8e3s4.f3j(Companion_instance_0.k2a());
  _this__u8e3s4.f3j(Companion_instance_1.k2a());
  _this__u8e3s4.f3j(Companion_instance_2.k2a());
  _this__u8e3s4.f3j(Companion_instance_3.k2a());
  _this__u8e3s4.f3j(Companion_instance_4.k2a());
  _this__u8e3s4.f3j(Companion_instance_5.k2a());
  _this__u8e3s4.f3j(Companion_instance_6.k2a());
  _this__u8e3s4.f3j(Companion_instance_7.k2a());
  _this__u8e3s4.f3j(Companion_instance_8.k2a());
  _this__u8e3s4.f3j(Companion_instance_9.k2a());
  _this__u8e3s4.f3j(Companion_getInstance_7().k2a());
  _this__u8e3s4.f3j(Companion_instance_57.k2a());
  var tmp_5 = Companion_getInstance_50().b2j(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_5, registerShared$lambda_5);
  var tmp_6 = Companion_getInstance_51().q2j(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_6, registerShared$lambda_6);
  var tmp_7 = Companion_instance_58.b2j(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_7, registerShared$lambda_7);
  _this__u8e3s4.f3j(Never_getInstance().k2a());
  _this__u8e3s4.f3j(Always_getInstance().k2a());
  var tmp_8 = Companion_instance_59.b2j(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_8, registerShared$lambda_8);
  var tmp_9 = Companion_instance_60.b2j(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_9, registerShared$lambda_9);
  var tmp_10 = Companion_instance_61.b2j(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_10, registerShared$lambda_10);
  var tmp_11 = Companion_instance_62.b2j(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_11, registerShared$lambda_11);
  var tmp_12 = Companion_instance_63.b2j(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_12, registerShared$lambda_12);
  var tmp_13 = Companion_instance_64.b2j(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_13, registerShared$lambda_13);
  var tmp_14 = Companion_instance_65.b2j(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_14, registerShared$lambda_14);
  var tmp_15 = Companion_instance_66.b2j(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_15, registerShared$lambda_15);
  var tmp_16 = Companion_instance_67.b2j(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_16, registerShared$lambda_16);
  var tmp_17 = Companion_instance_68.b2j(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_17, registerShared$lambda_17);
  var tmp_18 = Companion_instance_69.b2j(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_18, registerShared$lambda_18);
  _this__u8e3s4.f3j(Companion_instance_70.k2a());
  var tmp_19 = Companion_getInstance_52().b2j(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_19, registerShared$lambda_19);
  _this__u8e3s4.f3j(Companion_instance_71.k2a());
  var tmp_20 = Companion_getInstance_53().b2j(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_20, registerShared$lambda_20);
  _this__u8e3s4.f3j(Companion_instance_72.k2a());
  _this__u8e3s4.f3j(Companion_instance_73.k2a());
  _this__u8e3s4.f3j(Companion_instance_74.k2a());
  _this__u8e3s4.f3j(Companion_instance_75.k2a());
  _this__u8e3s4.f3j(Companion_instance_76.k2a());
  var tmp_21 = Companion_instance_77.a3l(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_21, registerShared$lambda_21);
  var tmp_22 = Companion_instance_78.a3l(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_22, registerShared$lambda_22);
  var tmp_23 = Companion_instance_79.a3l(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_23, registerShared$lambda_23);
  var tmp_24 = Companion_instance_80.a3l(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_24, registerShared$lambda_24);
  var tmp_25 = Companion_instance_81.a3l(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_25, registerShared$lambda_25);
  var tmp_26 = Companion_instance_82.a3l(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_26, registerShared$lambda_26);
  var tmp_27 = Companion_instance_83.b3l(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_27, registerShared$lambda_27);
  var tmp_28 = Companion_getInstance_54().b3l(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_28, registerShared$lambda_28);
  var tmp_29 = Companion_instance_84.b2j(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_29, registerShared$lambda_29);
  var tmp_30 = Companion_getInstance_55().q2j(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_30, registerShared$lambda_30);
  var tmp_31 = Companion_getInstance_56().q2j(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_31, registerShared$lambda_31);
  var tmp_32 = Companion_getInstance_57().q2j(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_32, registerShared$lambda_32);
  var tmp_33 = Companion_instance_85.b2j(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_33, registerShared$lambda_33);
  _this__u8e3s4.f3j(Nothing_getInstance().k2a());
  var tmp_34 = Companion_instance_86.b2j(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_34, registerShared$lambda_34);
  var tmp_35 = Companion_instance_87.b2j(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_35, registerShared$lambda_35);
  var tmp_36 = Companion_instance_88.b2j(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_36, registerShared$lambda_36);
  var tmp_37 = Companion_instance_89.b2j(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_37, registerShared$lambda_37);
  var tmp_38 = Companion_instance_90.b2j(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_38, registerShared$lambda_38);
  var tmp_39 = Companion_instance_91.b2j(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_39, registerShared$lambda_39);
  var tmp_40 = Companion_instance_92.b2j(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_40, registerShared$lambda_40);
  _this__u8e3s4.f3j(Companion_instance_93.k2a());
  var tmp_41 = Companion_instance_94.b2j(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_41, registerShared$lambda_41);
  var tmp_42 = Companion_instance_95.b2j(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_42, registerShared$lambda_42);
  var tmp_43 = Companion_instance_96.b2j(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_43, registerShared$lambda_43);
  var tmp_44 = Companion_instance_97.b2j(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_44, registerShared$lambda_44);
  var tmp_45 = Companion_instance_98.b2j(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_45, registerShared$lambda_45);
  var tmp_46 = Companion_instance_99.b2j(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_46, registerShared$lambda_46);
  var tmp_47 = Companion_getInstance_58().b2j(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_47, registerShared$lambda_47);
  var tmp_48 = Companion_instance_100.b2j(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_48, registerShared$lambda_48);
  var tmp_49 = Companion_instance_101.b2j(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_49, registerShared$lambda_49);
  var tmp_50 = Companion_instance_102.b2j(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_50, registerShared$lambda_50);
  var tmp_51 = Companion_instance_103.b2j(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_51, registerShared$lambda_51);
  var tmp_52 = Companion_instance_104.b2j(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_52, registerShared$lambda_52);
  var tmp_53 = Companion_getInstance_59().b2j(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_53, registerShared$lambda_53);
  var tmp_54 = Companion_instance_105.b2j(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_54, registerShared$lambda_54);
  var tmp_55 = Companion_instance_106.b2j(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_55, registerShared$lambda_55);
  var tmp_56 = Companion_instance_107.b2j(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_56, registerShared$lambda_56);
  var tmp_57 = Companion_getInstance_60().b2j(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_57, registerShared$lambda_57);
  var tmp_58 = Companion_getInstance_61().b2j(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_58, registerShared$lambda_58);
  var tmp_59 = Companion_getInstance_62().b2j(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_59, registerShared$lambda_59);
  var tmp_60 = Companion_getInstance_63().b2j(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_60, registerShared$lambda_60);
  var tmp_61 = Companion_instance_108.b2j(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_61, registerShared$lambda_61);
  _this__u8e3s4.f3j(Companion_getInstance_64().k2a());
  var tmp_62 = Companion_getInstance_65().b2j(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_62, registerShared$lambda_62);
  var tmp_63 = Companion_getInstance_66().r3l(NothingSerializer(), NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_63, registerShared$lambda_63);
  var tmp_64 = Companion_getInstance_67().b2j(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_64, registerShared$lambda_64);
  var tmp_65 = Companion_getInstance_68().b2j(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_65, registerShared$lambda_65);
  var tmp_66 = Companion_getInstance_69().b2j(NothingSerializer()).az().h10();
  _this__u8e3s4.y3j(tmp_66, registerShared$lambda_66);
  _this__u8e3s4.f3j(Companion_getInstance_70().k2a());
  _this__u8e3s4.f3j(Companion_instance_109.k2a());
}
function registerShared$lambda(it) {
  return Companion_getInstance_32().x2y(it[0], it[1]);
}
function registerShared$lambda_0(it) {
  return Companion_getInstance_34().c3k(it[0]);
}
function registerShared$lambda_1(it) {
  return Companion_getInstance_35().c3k(it[0]);
}
function registerShared$lambda_2(it) {
  return Companion_getInstance_47().b2j(it[0]);
}
function registerShared$lambda_3(it) {
  return Companion_instance_55.l3k(it[0]);
}
function registerShared$lambda_4(it) {
  return Companion_instance_56.b2j(it[0]);
}
function registerShared$lambda_5(it) {
  return Companion_getInstance_50().b2j(it[0]);
}
function registerShared$lambda_6(it) {
  return Companion_getInstance_51().q2j(it[0]);
}
function registerShared$lambda_7(it) {
  return Companion_instance_58.b2j(it[0]);
}
function registerShared$lambda_8(it) {
  return Companion_instance_59.b2j(it[0]);
}
function registerShared$lambda_9(it) {
  return Companion_instance_60.b2j(it[0]);
}
function registerShared$lambda_10(it) {
  return Companion_instance_61.b2j(it[0]);
}
function registerShared$lambda_11(it) {
  return Companion_instance_62.b2j(it[0]);
}
function registerShared$lambda_12(it) {
  return Companion_instance_63.b2j(it[0]);
}
function registerShared$lambda_13(it) {
  return Companion_instance_64.b2j(it[0]);
}
function registerShared$lambda_14(it) {
  return Companion_instance_65.b2j(it[0]);
}
function registerShared$lambda_15(it) {
  return Companion_instance_66.b2j(it[0]);
}
function registerShared$lambda_16(it) {
  return Companion_instance_67.b2j(it[0]);
}
function registerShared$lambda_17(it) {
  return Companion_instance_68.b2j(it[0]);
}
function registerShared$lambda_18(it) {
  return Companion_instance_69.b2j(it[0]);
}
function registerShared$lambda_19(it) {
  return Companion_getInstance_52().b2j(it[0]);
}
function registerShared$lambda_20(it) {
  return Companion_getInstance_53().b2j(it[0]);
}
function registerShared$lambda_21(it) {
  return Companion_instance_77.a3l(it[0]);
}
function registerShared$lambda_22(it) {
  return Companion_instance_78.a3l(it[0]);
}
function registerShared$lambda_23(it) {
  return Companion_instance_79.a3l(it[0]);
}
function registerShared$lambda_24(it) {
  return Companion_instance_80.a3l(it[0]);
}
function registerShared$lambda_25(it) {
  return Companion_instance_81.a3l(it[0]);
}
function registerShared$lambda_26(it) {
  return Companion_instance_82.a3l(it[0]);
}
function registerShared$lambda_27(it) {
  return Companion_instance_83.b3l(it[0]);
}
function registerShared$lambda_28(it) {
  return Companion_getInstance_54().b3l(it[0]);
}
function registerShared$lambda_29(it) {
  return Companion_instance_84.b2j(it[0]);
}
function registerShared$lambda_30(it) {
  return Companion_getInstance_55().q2j(it[0]);
}
function registerShared$lambda_31(it) {
  return Companion_getInstance_56().q2j(it[0]);
}
function registerShared$lambda_32(it) {
  return Companion_getInstance_57().q2j(it[0]);
}
function registerShared$lambda_33(it) {
  return Companion_instance_85.b2j(it[0]);
}
function registerShared$lambda_34(it) {
  return Companion_instance_86.b2j(it[0]);
}
function registerShared$lambda_35(it) {
  return Companion_instance_87.b2j(it[0]);
}
function registerShared$lambda_36(it) {
  return Companion_instance_88.b2j(it[0]);
}
function registerShared$lambda_37(it) {
  return Companion_instance_89.b2j(it[0]);
}
function registerShared$lambda_38(it) {
  return Companion_instance_90.b2j(it[0]);
}
function registerShared$lambda_39(it) {
  return Companion_instance_91.b2j(it[0]);
}
function registerShared$lambda_40(it) {
  return Companion_instance_92.b2j(it[0]);
}
function registerShared$lambda_41(it) {
  return Companion_instance_94.b2j(it[0]);
}
function registerShared$lambda_42(it) {
  return Companion_instance_95.b2j(it[0]);
}
function registerShared$lambda_43(it) {
  return Companion_instance_96.b2j(it[0]);
}
function registerShared$lambda_44(it) {
  return Companion_instance_97.b2j(it[0]);
}
function registerShared$lambda_45(it) {
  return Companion_instance_98.b2j(it[0]);
}
function registerShared$lambda_46(it) {
  return Companion_instance_99.b2j(it[0]);
}
function registerShared$lambda_47(it) {
  return Companion_getInstance_58().b2j(it[0]);
}
function registerShared$lambda_48(it) {
  return Companion_instance_100.b2j(it[0]);
}
function registerShared$lambda_49(it) {
  return Companion_instance_101.b2j(it[0]);
}
function registerShared$lambda_50(it) {
  return Companion_instance_102.b2j(it[0]);
}
function registerShared$lambda_51(it) {
  return Companion_instance_103.b2j(it[0]);
}
function registerShared$lambda_52(it) {
  return Companion_instance_104.b2j(it[0]);
}
function registerShared$lambda_53(it) {
  return Companion_getInstance_59().b2j(it[0]);
}
function registerShared$lambda_54(it) {
  return Companion_instance_105.b2j(it[0]);
}
function registerShared$lambda_55(it) {
  return Companion_instance_106.b2j(it[0]);
}
function registerShared$lambda_56(it) {
  return Companion_instance_107.b2j(it[0]);
}
function registerShared$lambda_57(it) {
  return Companion_getInstance_60().b2j(it[0]);
}
function registerShared$lambda_58(it) {
  return Companion_getInstance_61().b2j(it[0]);
}
function registerShared$lambda_59(it) {
  return Companion_getInstance_62().b2j(it[0]);
}
function registerShared$lambda_60(it) {
  return Companion_getInstance_63().b2j(it[0]);
}
function registerShared$lambda_61(it) {
  return Companion_instance_108.b2j(it[0]);
}
function registerShared$lambda_62(it) {
  return Companion_getInstance_65().b2j(it[0]);
}
function registerShared$lambda_63(it) {
  return Companion_getInstance_66().r3l(it[0], it[1]);
}
function registerShared$lambda_64(it) {
  return Companion_getInstance_67().b2j(it[0]);
}
function registerShared$lambda_65(it) {
  return Companion_getInstance_68().b2j(it[0]);
}
function registerShared$lambda_66(it) {
  return Companion_getInstance_69().b2j(it[0]);
}
//region block: exports
export {
  prepareModelsShared as prepareModelsShared26ns7flh6i65f,
};
//endregion

//# sourceMappingURL=prepareModelsShared.mjs.map
